<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <div class="search-wrapper">
        <Form
          ref="searchForm"
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
        >
          <Row type="flex" flex="end">
            <FormItem label="">
              <Input
                v-model.trim="searchConds.searchStr"
                placeholder="请输入学校单位名称"
                clearable
                class="search-input-430"
              ></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.orgKind"
                placeholder="请选择单位类别"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in orgKindList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Cascader
                v-model="searchConds.area"
                placeholder="请选择所属行政区"
                :data="regionDataList"
                clearable
                @on-change="handelAreaChange"
              ></Cascader>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.coSts"
                placeholder="请选择合作状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in cooperationList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.isPayWages"
                placeholder="请输入参与平台发送教师工资"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in sendSalaryList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="searchConds.infoSts"
                placeholder="请选择信息完善状态"
                clearable
                filterable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in completeStatusList"
                  :key="index"
                  :value="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>

            <Button type="primary" @click="handleSearch">确定</Button>
            <Button class="search-430" @click="handleReset">重置</Button></Row>
        </Form>
      </div>

      <div class="table-title-special-430 flex justify-content_end">
        <div class="">
          <Button
            type="primary"
            style="margin-right: 20px"
            @click="handleOpenBatch"
          >批量设置</Button>
          <Button
            class="op-btn"
            type="primary"
            @click="handleTrainBtn"
          >自关联培训服务</Button>
          <!-- <EditButton
          redirect-url="operatingCenter/organization/org/Index"
          class="search-430"
        ></EditButton> -->
        </div>
      </div>
    </div>

    <div class="table">
      <Table
        ref="selection"
        border
        :columns="tableColumns"
        :data="tableData"
        :loading="loading"
        :max-height="tableHeight"
        @on-selection-change="handleSelectData"
      >
        <template slot="action" slot-scope="{ row }">
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToDetail(row)"
          >查看详情</span>
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToManage(row)"
          >管理</span>
          <span
            class="ordinary-color-430"
            @click="handleOpenCode(row)"
          >学校小程序码</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>

    <!-- 自关联培训服务 -->
    <Modal v-model="modalTrainSchool" width="1200" title="自关联培训服务添加">
      <div class="page_modal">
        <Form :label-width="0" inline>
          <div style="margin-right: 30px; display: inline-block">
            <span>提示：以下是</span>
            <span style="color: #ff0000">入围 {{ trainEduName }} </span>
            <span>的服务校区，学校可通过检索添加已达成协议的服务并报送教育局审批。</span>
          </div>
          <!-- 服务名称 -->
          <FormItem label="">
            <span>服务名称：</span>
            <Input
              v-model="trainOrgName"
              placeholder="请输入"
              style="width: 250px"
              clearable
            ></Input>
          </FormItem>
          <Button
            type="primary"
            class="btn"
            @click="getTrainAssociatedOrg"
          >查询</Button>
        </Form>
        <div class="table-box">
          <Table
            ref="selection"
            border
            :columns="trainOrgTableColumn"
            :data="trainOrgTableData"
            :loading="trainOrgTableLoading"
            @on-selection-change="handleSelectOrgData"
          >
          </Table>
        </div>
        <div class="page-wrap" style="margin-top: 20px; text-align: right">
          <Page
            :total="trainOrgPageInfo.total"
            show-total
            show-elevator

            :current="trainOrgPageInfo.pageNum"
            :page-size="trainOrgPageInfo.pageSize"
            @on-change="changeTrainOrgPage"
          ></Page>
        </div>
        <div class="page_foot">
          <div
            class="box-title-430"
            style="font-size: 18px; font-weight: bold; margin-bottom: 10px"
          >
            学校已合作服务校区名单
          </div>
          <div class="coo-orglist">
            <!-- <div
              v-for="(item, key) in 100"
              :key="key"
              class="text_item"
              :value="item"
            >
              <div class="item_school">
                <span>{{ item }}</span>
              </div>
            </div> -->
            <div
              v-for="(item, key) in hadCooOrgList"
              :key="key"
              class="text_item"
              :value="item.orgId"
            >
              <div class="item_school">
                <span>{{ item.orgName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="handleSubmitOrg">提交</Button>
        <Button type="text" @click="handleCancleOrg">取消</Button>
      </div>
    </Modal>

    <Modal
      v-model="showCodeModal"
      width="1000"
      title="学校小程序码"
      footer-hide
    >
      <div class="code-content">
        <img :src="codeSrc" :alt="codeSchoolName + '小程序码'">
        <div class="school-text">{{ codeSchoolName }}</div>
        <Alert type="warning">
          <p>1、学校小程序码为学校唯一的小程序码</p>
          <p>2、可粘贴在告家长一封信中，家长无需再次选择学校，自动默认选中。</p>
        </Alert>
      </div>
      <div class="btn-box">
        <Button @click="handleToCloseCodeModal">关闭</Button>
        <Button
          type="primary"
          :disabled="!canDownloadCode"
          @click="handleToDownloadCode"
        >下载小程序码</Button>
      </div>
    </Modal>
    <Modal v-model="batchShow" width="70" :title="modelTitle" footer-hide>
      <div class="modal-content">
        <!-- <div class="top-box">
          <div v-for="item in tabList" :key="item.name" class="top-item">{{ item.name }}</div>
        </div> -->
        <!-- <Tabs v-model="tabActive" type="card">
          <TabPane v-for="(item,index) in tabList" :key="item.name" :label="item.name" :name="index+''"></TabPane>
        </Tabs> -->
        <div v-if="tabList.length>1" class="tab-box">
          <div
            v-for="(item, index) in tabList"
            :key="index"
            :class="index === tabActive ? 'tab-item-active' : ''"
            class="tab-item"
            @click="handleSwitchTab(index)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="tab-content">
          <div v-show="tabLeft.length > 1" class="content-left">
            <div
              v-for="(item, index) in tabLeft"
              :key="index"
              class="top-item"
              :class="tabLeftActive === index ? 'top-item-active' : ''"
              @click="handleChangeTabLeft(index)"
            >
              {{ item.name }}
            </div>
          </div>

          <div class="content-right" style="padding-bottom: 50px">
            <Form
              v-show="activeItem === '家长端自动退款设置'"
              :label-width="180"
              class="form-content"
              style="position: relative"
            >
              <FormItem label="是否允许学生未入班前发起退款后系统自动审批：">
                <div
                  class="flex flexrow flexsb"
                  style="position: relative; top: 8px"
                >
                  <RadioGroup v-model="isEnable">
                    <Radio :label="0">否</Radio>
                    <Radio :label="1">是</Radio>
                  </RadioGroup>
                  <!-- <Button
                    type="primary"
                    style="width: 100px"
                    @click="handleToOpenRec"
                  >操作记录</Button> -->
                </div>
              </FormItem>
              <FormItem
                v-show="isEnable == 1"
                label="对应订单所属学期："
                :required="true"
              >
                <CascaderYearTerms
                  ref="cascaderYearTerms"
                  style="width: 200px"
                  :has-default-value="true"
                  :placeholder="`请选择学期`"
                  :clearable="true"
                >
                </CascaderYearTerms>
              </FormItem>
              <FormItem
                v-show="isEnable == 1"
                label="自动退款截止时间："
                :required="true"
                style="padding-bottom: 80px"
              >
                <DatePicker
                  :value="autoRefundTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="自动退款截止时间"
                  style="width: 200px"
                  @on-change="handleTime"
                ></DatePicker>
                <p>
                  ①否：表示家长发起的退款，需经学校教务人员审批后方可进行才退款。
                </p>
                <p>
                  ②是：表示在该商品的
                  <span class="redweight">已付款</span> 人数<span class="redweight">且未入班</span>时，家长端发起的退款后，对应学期下的订单在<span class="redweight">自动退款截止时间前</span>，系统自动将自动审批通过家长的退款申请单，并进行所申请节次的全额退款。
                </p>
                <p>③系统每5分钟定时执行符合条件的自动退款处理单。</p>
              </FormItem>
            </Form>

            <Form
              v-show="activeItem === '学校端是否可见审批'"
              :label-width="210"
              class="form-content"
              style="position: relative"
            >
              <FormItem label="学校端是否可见操作操作按钮：">
                <div
                  class="flex flexrow flexsb"
                  style="position: relative; top: 8px"
                >
                  <RadioGroup v-model="configStatus">
                    <Radio :label="0">否</Radio>
                    <Radio :label="1">是</Radio>
                  </RadioGroup>
                  <Button
                    type="primary"
                    style="width: 100px"
                    @click="handleToOpenRec('SET_CONFIG_OF_REFUND_APPROVE_SCH_PERMISSION')"
                  >操作记录</Button>
                </div>
                <p>①否：学校端不可见审批退款按钮（订单退款、请假可退款、批量退款）。即使用户有权限也不可见。</p>
                <p>②是：学校端有权限的用户可见</p>
              </FormItem>
            </Form>

            <div v-if="showSaveAndCancelBtn" class="showbtn-block">
              <Button style="margin-right: 16px" @click="handleCancel">取消</Button>
              <Button type="primary" @click="handleSaveBtn">保存</Button>
            </div>
          </div>

        </div>
      </div>
    </Modal>
    <CheckCodeModal
      ref="smsCodeModalRef"
      :title="`自动退款设置确认`"
      :check-type="`setAutoRefund`"
      :modal-loading="modalLoading"
      @on-finish="delTrue"
    >
      <template #header>
        <div>
          <p style="margin-bottom: 8px">
            请仔细核对当前的退款设置方式，设置后立即生效！
          </p>
        </div>
      </template>
    </CheckCodeModal>
    <RecModal ref="recModal" :code-type-map="codeTypeMap"></RecModal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { regionDataList } from '@/utils/dictionary';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import commonApi from '@/request/common/index';
import { opeEduListColumns } from '@/pages/assetsModules/manageData.js';
import {
  orgKindList,
  cooperationList,
  completeStatusList,
  sendSalaryList,
  changeDictionaries
} from '@/utils/dictionary.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import CheckCodeModal from '../assets/components/CheckCodeModal.vue';
import RecModal from '@c/RecModal.vue';
// import EditButton from '@/pages/assetsModules/EditButton';
import {
  tableColumnsWidth,
  key,
  slot
} from '@/assets/js/resetTableStyle';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'CompanySchoolMage',
  components: {
    CascaderYearTerms,
    CheckCodeModal,
    RecModal
  },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      regionDataList: [],
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      searchConds: {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        isPayWages: -1, // 是否参与平台发送教师工资  1：参与 0：不参与
        coSts: null // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
      },
      sendSalaryList: [...sendSalaryList],
      sendSalaryColor: [
        'state-red-430',
        'state-green-430'
      ],
      // tableColumns: [...opeEduListColumns],
      orgKindList, // 单位类别列表
      cooperationList, // 合作状态列表
      completeStatusList, // 信息完善状态
      tableData: [],
      selectTableData: [], // 勾选的学校数据
      selectSchoolIds: '', // 勾选的学校id
      modalTrainSchool: false, // 自关联培训服务弹窗
      trainEduName: '', // 自关联教育局名称
      trainOrgName: '', // 自关联培训服务名称
      trainOrgTableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '服务名称',
          key: 'name',
          align: 'center'
        }
      ],
      trainOrgTableData: [], // 自关联服务机构数据
      trainOrgTableLoading: false,
      selectOrgData: [], // 勾选的机构数据
      selectOrgIds: [], // 勾选的机构id
      trainOrgPageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      loading: false,
      hadCooOrgList: [], // 学校已合作机构校区名单
      showCodeModal: false,
      codeSrc: '',
      codeSchoolName: '',
      canDownloadCode: true,
      batchShow: false,
      modalLoading: false,
      tabActive: 0, // 第几个tab选中
      tabLeftActive: 0,
      tabList: [
        {
          name: '退款设置',
          tabLeft: [
            {
              name: '家长端自动退款设置'
            },
            {
              name: '学校端是否可见审批'
            }
          ]
        }
        // {
        //   name: '服务协议',
        //   tabLeft: [
        //     {
        //       name: '服务协议'
        //     }
        //   ]
        // }
      ],
      isEnable: 0,
      configStatus: 0,
      autoRefundTime: '',
      codeTypeMap: {
        'AUTO_REFUND': '自动退款',
        'SET_CONFIG_OF_REFUND_APPROVE_SCH_PERMISSION': '学校端是否可见操作操作按钮'
      }
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle', 'theUserIdentity']),
    tableColumns() {
      const columns = [...opeEduListColumns];
      columns.splice(3, 0, key('参与平台发放教师工资', 'isPayWages', tableColumnsWidth.type9, {
        render: (h, params) => {
          return h('div', {
            class: (params.row.isPayWages === 0 || params.row.isPayWages === 1) ? this.sendSalaryColor[params.row.isPayWages] : ''
          }, [(params.row.isPayWages === 0 || params.row.isPayWages === 1) ? changeDictionaries(sendSalaryList)[params.row.isPayWages] : '-']);
        },
        align: 'center'
      }));
      columns.splice(-1, 1, slot('操作', 'action', 280, { fixed: 'right' }));
      return columns;
    },
    orgIdList() {
      return this.selectTableData.map(item => {
        return item.orgId;
      });
    },
    tabLeft() {
      return this.tabList[this.tabActive].tabLeft;
    },
    activeItem() {
      return this.tabList[this.tabActive].tabLeft[this.tabLeftActive].name;
    },
    // 是否展示  保存、取消按钮
    showSaveAndCancelBtn() {
      const hideBtnList = ['服务协议'];
      const index = hideBtnList.findIndex(item => {
        return item === this.activeItem;
      });
      return index === -1;
    },
    modelTitle() {
      return `批量设置（已选${this.selectTableData.length}）`;
    }
  },
  created() {
    this.regionDataList = [...regionDataList];
    this.tableColumns.unshift({
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left'
    });
    this.getSchoolList();
    // 超管账号
    if (this.userInfo.userType === 5) {
      this.tableColumns.push({
        title: '创建账号',
        key: 'creatorName',
        minWidth: 180,
        align: 'center'
      });
    }
  },
  activated() {
    this.getSchoolList();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CompanySchoolMage');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE', 'DELETE_CACHEROUTE']),
    handleToOpenRec(recType) {
      this.$refs.recModal.handleShow({
        recType
      });
    },
    batchSuccess() {
      this.batchShow = false;
      this.selectTableData = [];
      this.getSchoolList();
    },
    handleOpenBatch() {
      if (this.selectTableData.length === 0) {
        return this.$Message.error('请勾选要批量设置的学校');
      }
      this.isEnable = 0;
      this.configStatus = 0;
      this.autoRefundTime = '';
      this.tabActive = 0; // 第几个tab选中
      this.tabLeftActive = 0;
      this.batchShow = true;
    },
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.searchConds = {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        isPayWages: -1, // 是否参与平台发送教师工资  1：参与 0：不参与
        coSts: null // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
      };
      this.pageInfo.pageNum = 1;
      this.getSchoolList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getSchoolList();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getSchoolList();
    },
    handlePageSize(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum === 1 && this.getSchoolList();
    },
    // 学校详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'operation_company_schoolMage_detail',
        query: { schoolId: row.orgId }
      });
    },
    // 管理
    handleToManage(row) {
      this.DELETE_CACHEROUTE('ResourceSchoolActionMage');
      this.$router.push({
        name: 'operation_company_schoolMage_actionmage',
        query: { schoolId: row.orgId, name: row.name }
      });
    },
    async getMiniProgramCode({ orgId, areaCode }) {
      return new Promise(async(resolve, reject) => {
        const params = {
          orgId,
          appId: areaCode === '440902' ? 'wxd2b7ecaaf92f5d6c' : 'wx00a58a23a3a3c098'// 茂名区用新的小程序，非茂名区用旧的小程序
        };
        const res = await operationAdmin.getParentsSmallProgramCodeApi(params);
        if (res.status === 200) {
          resolve(res.message);
        } else {
          reject('err');
        }
      });
    },
    async handleOpenCode(row) {
      let imgSrc = '';
      this.$Spin.show();
      try {
        imgSrc = await this.getMiniProgramCode({ orgId: row.orgId, areaCode: row.areaCode });
      } catch (err) {
        console.log(err);
      }
      this.codeSrc = `data:image/png;base64,${imgSrc}`;
      this.codeSchoolName = row.name;
      this.$Spin.hide();
      this.showCodeModal = true;
    },
    handleToCloseCodeModal() {
      this.showCodeModal = false;
    },
    handleToDownloadCode() {
      this.canDownloadCode = false;
      const downloadElement = document.createElement('a');
      const href = this.codeSrc;
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = `${this.codeSchoolName}小程序码`; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      this.canDownloadCode = true;
    },
    // 获取学校列表
    async getAdminSchoolList(params) {
      params.isPayWages === -1 ? params.isPayWages = null : '';
      const res = await operationAdmin.getSysSchoolsApi(params);
      this.loading = false;
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 查询学校列表
    async getSchoolList() {
      const { total, ...pageInfo } = this.pageInfo;
      const { area, ...searchConds } = this.searchConds;
      const params = { ...pageInfo, ...searchConds };
      this.loading = true;
      if (this.theUserIdentity === 'admin') {
        this.getAdminSchoolList(params);
        return;
      }

      const res = await operationAdmin.getListSchoolsNew(params);
      this.loading = false;
      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 获取表格选中的数据
    handleSelectData(selection) {
      this.selectTableData = selection;
      this.selectSchoolIds = '';
      this.selectTableData.forEach((item, index) => {
        if (index === 0) {
          this.selectSchoolIds += item.orgId;
        } else {
          this.selectSchoolIds += ',' + item.orgId;
        }
      });
    },
    // 点击自关联培训服务按钮
    handleTrainBtn() {
      if (this.selectTableData.length === 0) {
        return this.$Message.error('请勾选一条记录');
      }
      if (this.selectTableData.length !== 1) {
        return this.$Message.error('只能勾选一条记录');
      }
      this.trainEduName = this.selectTableData[0].bureauName;
      this.modalTrainSchool = true;
      this.getTrainAssociatedOrg();
      this.getTrainSchoolAssociatedOrg();
    },
    changeTrainOrgPage(page) {
      this.trainOrgPageInfo.pageNum = page;
      this.getTrainAssociatedOrg();
    },
    /* 自关联培训服务 */
    async getTrainAssociatedOrg() {
      const params = {
        orgName: this.trainOrgName,
        schoolId: this.selectSchoolIds,
        pageNum: this.trainOrgPageInfo.pageNum,
        pageSize: this.trainOrgPageInfo.pageSize
      };
      this.trainOrgTableLoading = true;
      const res = await operationAdmin.getAssociatedOrgNew(params);
      this.trainOrgTableLoading = false;
      if (res.status === 200) {
        this.trainOrgTableData = res.message.list;
        this.trainOrgPageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 自关联培训-学校已关联服务
    async getTrainSchoolAssociatedOrg() {
      const params = {
        schoolId: this.selectSchoolIds
      };
      const res = await operationAdmin.getSchoolAssociatedOrgNew(params);
      if (res.status === 200) {
        this.hadCooOrgList = res.message;
      } else {
        this.$Message.error(res.message);
      }
    },
    // 选择机构数据
    handleSelectOrgData(selection) {
      this.selectOrgData = selection;
      this.selectOrgIds = [];
      this.selectOrgIds = this.selectOrgData.map(item => {
        return item.orgId;
      });
      // this.selectOrgData.forEach((item, index) => {
      //   if (index === 0) {
      //     this.selectOrgIds += item.orgId;
      //   } else {
      //     this.selectOrgIds += ',' + item.orgId;
      //   }
      // });
    },
    // 提交
    handleSubmitOrg() {
      if (this.selectOrgData.length === 0) {
        return this.$Message.error('请选择关联培训服务');
      }
      this.postTraiSchool();
    },
    // 自关联培训-提交
    async postTraiSchool() {
      const params = {
        schoolId: this.selectSchoolIds,
        orgMode: 1,
        orgIds: this.selectOrgIds
      };
      const res = await operationAdmin.postSchoolAssociatedOrg(params);
      if (res.status === 200) {
        this.$Message.success('提交成功');
        this.modalTrainSchool = false;
        this.pageInfo.pageNum = 1;
        this.getSchoolList();
      } else {
        this.$Message.error('提交失败');
      }
    },
    // 关闭弹窗
    handleCancleOrg() {
      this.modalTrainSchool = false;
    },
    handleSwitchTab(index) {
      this.tabActive = index;
      this.tabLeftActive = 0;
    },
    handleChangeTabLeft(index) {
      this.tabLeftActive = index;
    },
    handleTime(v) {
      this.autoRefundTime = v;
    },
    // 取消
    handleCancel() {
      this.batchShow = false;
    },
    handleSaveBtn() {
      this.btnLoading = true;
      if (this.activeItem === '家长端自动退款设置') {
        if (this.isEnable == 1 && !this.autoRefundTime) {
          this.$Message.error('请选择自动退款截止时间');
          return;
        }
        const yearAr = this.$refs.cascaderYearTerms.getResult();
        if (this.isEnable == 1 && !yearAr[0]) {
          this.$Message.error('请选择对应订单所属学期');
          return;
        }
        this.$refs.smsCodeModalRef.handleShow();
        return;
      }
      if (this.activeItem === '学校端是否可见审批') {
        this.setSchoolCanCheckRefund();
        return;
      }
    },
    // 配置学校端是否可见审批退款
    async setSchoolCanCheckRefund() {
      // const params = {
      //   configStatus: this.configStatus,
      //   schoolIdList: this.orgIdList
      // };
      const list = this.selectTableData.map(item => {
        return {
          configStatus: this.configStatus,
          schoolId: item.orgId,
          schoolName: item.name
        };
      });
      try {
        this.$Spin.show();
        const res = await courseCenterApi.saveApproveRefundConfigApi(list);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
          this.batchSuccess();
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    async delTrue(code) {
      this.modalLoading = true;
      try {
        const yearTerms = this.$refs.cascaderYearTerms.getResult();
        const params = {
          'schoolIdList': this.orgIdList, // 学校Id
          'yearCode': yearTerms[0] || null, // 学年编码
          'termCode': yearTerms[1] || null, // 学期编码
          'autoRefundTime': this.autoRefundTime || null, // 必传， 开启时，时间大于当前时间，关闭时传当前时间
          'isEnable': this.isEnable, // 0关闭 1开启
          'phoneCode': code // 短信验证码
        };
        const res = await commonApi.batchSaveAutoRefundApi(params);
        if (res.status == 200) {
          this.$refs.smsCodeModalRef.handleHide();
          this.$Message.success('保存成功');
          this.batchSuccess();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.modalLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  height: 100%;
  box-sizing: border-box;
  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}
.col-center {
  padding: 0 8px;
  margin-bottom: 8px;
  button + button {
    margin-left: 16px;
  }
}
.code-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 300px;
    height: 300px;
  }
  .school-text {
    font-weight: 600;
    margin: 20px 0;
    font-size: 20px;
  }
  /deep/.ivu-alert-warning {
    width: 100%;
  }
  p {
    color: rgb(97, 150, 250);
    line-height: 30px;
  }
}
.btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 20px;
  }
}
.modal-content {
  // display: flex;
  .top-box {
    padding: 0 20px;
    flex-shrink: 0;
    border-bottom: 1px solid rgb(247, 248, 250);
    .top-item {
      display: inline-block;
      padding: 8px 16px;
      background: rgba(231, 238, 252, 0.5);
      color: rgb(54, 112, 232);
    }
    .top-item-active {
      display: inline-block;
      padding: 8px 16px;
      background: rgba(231, 238, 252, 0.5);
      color: rgb(54, 112, 232);
    }
  }
}
.coo-orglist {
  max-height: 300px;
  overflow: auto;
}
.tab-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 8px 16px;
    border: 1px solid #ccc;
    font-size: 24px !important;
    line-height: 24px;
    border-radius: 4px 4px 0 0;
    margin-bottom: -1px;
    background: rgb(240, 244, 249);
    color: rgb(127, 127, 127);
    cursor: pointer;
  }
  .tab-item + .tab-item {
    margin-left: 8px;
  }
  .tab-item-active {
    color: #6149f1;
    border-bottom: 1px solid #fff;
    background: transparent;
  }
}
.tab-content {
  display: flex;
  margin-top: 25px;

  .content-left {
    width: 16%;
    box-sizing: border-box;
    border: 1px solid #ccc;
    flex-shrink: 0;
    .top-item {
      padding: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .top-item-active {
      color: #6149f1;
      background: #efecfd;
    }
  }
  .content-right {
    width: 84%;
    padding-left: 24px;
    .form-content{
      height: 400px;
    }
  }

}
</style>
